import { Button, Tooltip } from '@cobliteam/ui/components';
import { memo } from 'react';

export interface DataTableActionProps {
  icon: any;
  tooltip?: string;
  onClick: () => void;
}

const DataTableAction = ({ icon, tooltip, onClick }: DataTableActionProps) => {
  return (
    <Tooltip enable={!!tooltip} content={tooltip} asChild delayDuration={0}>
      <Button variant='outlined' color='default' size='sm' icon={icon} onClick={onClick} data-testid='data-table-action' />
    </Tooltip>
  );
};

export default memo(DataTableAction);
